import { ModelBase } from 'store/model-base';
import { PaymentState, TransactionType } from 'my-account/constants';

export class Transaction extends ModelBase {
    public static storeName: string = 'transaction';

    public id: Id;
    public type: TransactionType;
    public state: PaymentState;
    public transactionDate: string;
    public title: string;
    public subtitle: string;
    public isLegacy: boolean;
    public amount?: number;

    public isPaid: boolean;
    public isPastDue: boolean;
    public isNextPayment: boolean;
    public isRefund: boolean;
    public isCredit: boolean;
    public isCreditReversal: boolean;
    public isOneTimePayment: boolean;
    public isQuickPayment: boolean;
    public isStatement: boolean;
    public isEstimated: boolean;

    public get description(): string {
        switch (this.type) {
            case TransactionType.ADDITIONAL_DEVICE_PAYMENT:
                return 'Additional Device Payment';
            case TransactionType.REFUND:
                return 'Refund';
            case TransactionType.BALANCE_PAYMENT:
                return 'Auto Payment';
            case TransactionType.ONETIME_PAYMENT:
                return 'One-Time Payment';
            case TransactionType.QUICK_PAYMENT:
                return 'Quick Payment';
            default:
                return '';
        }
    }

    public static create<T extends ModelBase>(initData: object): T {
        const transaction: Transaction = super.create<Transaction>(initData);

        transaction.isPaid = transaction.state === PaymentState.PAID;
        transaction.isPastDue = transaction.state === PaymentState.PAST_DUE;
        transaction.isNextPayment = transaction.state === PaymentState.PENDING;
        transaction.isRefund = transaction.type === TransactionType.REFUND;
        transaction.isCredit = transaction.type === TransactionType.CREDIT;
        transaction.isCreditReversal = transaction.type === TransactionType.CREDIT_REVERSAL;
        transaction.isOneTimePayment = transaction.type === TransactionType.ONETIME_PAYMENT;
        transaction.isQuickPayment = transaction.type === TransactionType.QUICK_PAYMENT;
        transaction.isStatement = transaction.type === TransactionType.STATEMENT;
        transaction.isEstimated = transaction.state === PaymentState.ESTIMATED;

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> transaction;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }
}
